import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	sortByAssignee: {
		id: 'software-releases-version-detail-issue-list.list-options.sorting.sorting-dropdown.sort-by-assignee',
		defaultMessage: 'Assignee',
		description: 'The label of the sort by assignee option',
	},
	sortByDateCreated: {
		id: 'software-releases-version-detail-issue-list.list-options.sorting.sorting-dropdown.sort-by-date-created',
		defaultMessage: 'Date created',
		description: 'The label of the sort by issue date created option',
	},
	sortByIssueKey: {
		id: 'software-releases-version-detail-issue-list.list-options.sorting.sorting-dropdown.sort-by-issue-key',
		defaultMessage: 'Issue key',
		description: 'The label of the sort by issue key option',
	},
	sortByPriority: {
		id: 'software-releases-version-detail-issue-list.list-options.sorting.sorting-dropdown.sort-by-priority',
		defaultMessage: 'Priority',
		description: 'The label of the sort by issue priority option',
	},
	sortByIssueStatusCategory: {
		id: 'software-releases-version-detail-issue-list.list-options.sorting.sorting-dropdown.sort-by-issue-status-category',
		defaultMessage: 'Status category',
		description: 'The label of the sort by issue status category option',
	},
	sortByIssueType: {
		id: 'software-releases-version-detail-issue-list.list-options.sorting.sorting-dropdown.sort-by-issue-type',
		defaultMessage: 'Type',
		description: 'The label of the sort by issue type option',
	},
	ascending: {
		id: 'software-releases-version-detail-issue-list.list-options.sorting.sorting-dropdown.ascending',
		defaultMessage: 'Ascending',
		description: 'The label of the ascending sort order option',
	},
	descending: {
		id: 'software-releases-version-detail-issue-list.list-options.sorting.sorting-dropdown.descending',
		defaultMessage: 'Descending',
		description: 'The label of the descending sort order option',
	},
	sortBy: {
		id: 'software-releases-version-detail-issue-list.list-options.sorting.sorting-dropdown.sort-by',
		defaultMessage: 'Sort by',
		description: 'The label of the sort dropdown',
	},
});
